module.exports = __webpack_public_path__ + "files/dff28d405f8a350bba4868b76a5d8639.png";